import { Link } from 'react-router-dom';
import { useSEO } from '../../utils/seo';

export default function HakkimizdaPage() {
  // SEO Configuration
  useSEO({
    title: 'Hakkımızda | Hatay İlkyardım Eğitim Merkezi İskenderun - ASSA Akademi',
    description: 'ASSA Akademi, 2010\'dan beri Hatay İskenderun, Payas, Dörtyol ve Antakya\'da ilkyardım, yangın güvenliği ve iş güvenliği eğitimleri veriyor. 10.000+ kursiyere eğitim verdik. ☎ 0850 346 27 72',
    keywords: 'ASSA Akademi hakkında, hatay eğitim merkezi, iskenderun ilkyardım kurumu, payas eğitim kurumu, dörtyol ilkyardım merkezi, antakya iş güvenliği eğitimi, hatay ilkyardım eğitim merkezi',
    canonical: '/hakkimizda',
    ogTitle: 'Hakkımızda | Hatay İlkyardım Eğitim Merkezi - ASSA Akademi',
    ogDescription: 'Hatay İskenderun, Payas, Dörtyol ve Antakya\'da güvenilir eğitim hizmetleri. 2010\'dan beri 10.000+ kursiyere profesyonel eğitim.',
    ogImage: 'https://static.readdy.ai/image/69983b9b992309f9f345f22b715baa7c/168d15a60f9fa69a47dd6f5cc2c64efc.png',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "@id": "https://www.hatayilkyardım.com.tr/hakkimizda#webpage",
      "url": "https://www.hatayilkyardım.com.tr/hakkimizda",
      "name": "Hakkımızda - ASSA Akademi Hatay İlkyardım Eğitim Merkezi",
      "description": "ASSA Akademi, 2010'dan beri Hatay İskenderun, Payas, Dörtyol ve Antakya'da iş güvenliği ve mesleki eğitim alanında uzmanlaşmış profesyonel bir eğitim kurumudur.",
      "isPartOf": {
        "@id": "https://www.hatayilkyardım.com.tr/#website"
      },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Ana Sayfa",
            "item": "https://www.hatayilkyardım.com.tr/"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Hakkımızda",
            "item": "https://www.hatayilkyardım.com.tr/hakkimizda"
          }
        ]
      },
      "mainEntity": {
        "@type": "EducationalOrganization",
        "name": "ASSA Akademi",
        "foundingDate": "2010",
        "numberOfEmployees": "10-20",
        "slogan": "Hatay'ın Güvenilir Eğitim Merkezi",
        "knowsAbout": ["İlkyardım Eğitimi", "Yangın Güvenliği", "Yüksekte Çalışma", "Hijyen Eğitimi", "MYK Danışmanlığı"]
      }
    }
  });

  const whatsappNumber = '905354971053';
  const handleWhatsAppClick = () => {
    const message = 'Merhaba, ASSA Akademi hakkında bilgi almak istiyorum.';
    window.open(`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-gradient-to-r from-gray-900 to-gray-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="mb-8">
            <Link to="/" className="text-teal-400 hover:text-teal-300 flex items-center text-sm whitespace-nowrap">
              <i className="ri-arrow-left-line mr-2"></i>
              Ana Sayfaya Dön
            </Link>
          </nav>
          <h1 className="text-5xl font-bold mb-4">Hakkımızda</h1>
          <p className="text-xl text-gray-300 max-w-3xl">
            Hatay İskenderun'da güvenilir eğitim hizmetleri sunan profesyonel ekibimizle tanışın
          </p>
        </div>
      </header>

      {/* About Content */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                ASSA Akademi Kimdir?
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  ASSA Akademi, Hatay İskenderun'da faaliyet gösteren, iş güvenliği ve mesleki eğitim alanında uzmanlaşmış profesyonel bir eğitim kurumudur. Temel ilkyardım eğitimleri, ilkyardım güncelleme eğitimleri, ilkyardım eğitici eğitimi, yüksekte çalışma eğitimleri, hijyen eğitimleri, yangın eğitimleri ve mesleki eğitim konularında kapsamlı programlar sunmaktayız.
                </p>
                <p>
                  Profesyonel sertifikalı eğitimlerimiz ile bireylerin ve kurumların iş güvenliği standartlarını yükseltmeyi, çalışanların güvenli çalışma ortamlarında görev yapmalarını sağlamayı hedefliyoruz. Ayrıca MYK danışmanlığı hizmetlerimizle mesleki yeterlilik süreçlerinde yanınızdayız.
                </p>
                <p>
                  Deneyimli eğitmen kadromuz, modern eğitim materyallerimiz ve uygulamalı eğitim yaklaşımımız ile sektörde fark yaratıyoruz. Hatay bölgesinde iş güvenliği ve mesleki eğitim alanında güvenilir bir partner olarak hizmet vermekteyiz.
                </p>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/d14e8e5719dbc1867a9b92aa10f22b2f.jpg"
                alt="ASSA Akademi Eğitim Merkezi"
                className="rounded-2xl shadow-2xl w-full h-auto object-cover object-top"
              />
            </div>
          </div>

          {/* Mission & Vision */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20">
            <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 text-white">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-6">
                <i className="ri-target-line text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Misyonumuz</h3>
              <p className="text-teal-50 leading-relaxed">
                Hatay ve çevre illerde iş güvenliği bilincini artırmak, kaliteli ve uygulamalı eğitimlerle bireylerin ve kurumların güvenli çalışma standartlarına ulaşmasını sağlamak, mesleki yeterlilik süreçlerinde rehberlik etmektir.
              </p>
            </div>

            <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 text-white">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-6">
                <i className="ri-eye-line text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Vizyonumuz</h3>
              <p className="text-gray-300 leading-relaxed">
                Türkiye'nin güney bölgesinde iş güvenliği ve mesleki eğitim alanında öncü kurum olmak, sürekli gelişen eğitim programlarımız ve yenilikçi yaklaşımımızla sektöre değer katmaya devam etmektir.
              </p>
            </div>
          </div>

          {/* Values */}
          <div className="mb-20">
            <h2 className="text-4xl font-bold text-gray-900 text-center mb-12">
              Değerlerimiz
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-4xl text-teal-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Güvenilirlik</h3>
                <p className="text-gray-600">
                  Resmi onaylı sertifikalarımız ve profesyonel yaklaşımımızla güvenilir eğitim hizmeti sunuyoruz.
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-star-line text-4xl text-teal-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Kalite</h3>
                <p className="text-gray-600">
                  Deneyimli eğitmenlerimiz ve modern eğitim materyallerimizle yüksek kaliteli eğitim sağlıyoruz.
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-hand-heart-line text-4xl text-teal-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Müşteri Odaklılık</h3>
                <p className="text-gray-600">
                  Esnek eğitim saatlerimiz ve kişiye özel programlarımızla ihtiyaçlarınıza uygun çözümler üretiyoruz.
                </p>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-2xl p-12">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
              <div>
                <div className="text-4xl font-bold text-teal-600 mb-2">10.000+</div>
                <div className="text-gray-700 font-medium">Eğitim Verilen Kursiyer</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-teal-600 mb-2">8+</div>
                <div className="text-gray-700 font-medium">Farklı Eğitim Programı</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-teal-600 mb-2">100%</div>
                <div className="text-gray-700 font-medium">Resmi Onaylı Sertifika</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-teal-600 mb-2">15+</div>
                <div className="text-gray-700 font-medium">Yıllık Deneyim</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-gradient-to-r from-teal-600 to-teal-700 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Bizimle Çalışmak İster Misiniz?
          </h2>
          <p className="text-xl text-teal-50 mb-8">
            Profesyonel eğitim hizmetlerimiz hakkında detaylı bilgi almak için iletişime geçin
          </p>
          <button
            onClick={handleWhatsAppClick}
            className="bg-white hover:bg-gray-100 text-teal-600 px-8 py-4 rounded-lg font-bold text-lg transition-all inline-flex items-center space-x-2 whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            <span>WhatsApp ile İletişime Geç</span>
          </button>
        </div>
      </section>

      {/* Floating WhatsApp Button */}
      <button
        onClick={handleWhatsAppClick}
        className="fixed bottom-6 right-6 w-14 h-14 bg-teal-600 hover:bg-teal-700 text-white rounded-full shadow-lg hover:shadow-xl transition-all z-40 flex items-center justify-center"
        aria-label="WhatsApp ile iletişime geç"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </button>
    </div>
  );
}